(function () {
    'use strict';

    angular
        .module('app')
        .factory('CorporateTemplateService', CorporateTemplateService);


    function CorporateTemplateService($http, $q, $rootScope, WebAPIUrl) {

        var service = {
            getCurrentCorporateTemplateItems: getCurrentCorporateTemplateItems,
            createCorporateTemplate: createCorporateTemplate
        };


        return service;

       
        function getCurrentCorporateTemplateItems() {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/CorporateTemplate/CurrentCorporateTemplateItems',
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;            
        };

        function createCorporateTemplate(corporateTemplateItemData) {

            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/CorporateTemplate/CreateCorporateTemplate",
                data: { '': corporateTemplateItemData },
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

    }

})();